import { useCallback, useState } from "react";
import CreativeSourceResponseResource from "common/resources/Project/Config/CreativeSource/CreativeSourceResponseResource";
import { CreativeSourceCreateOperation, CreativeSourceEditOperation } from "..";

export enum ECreativeSourceModal {
	CREATE_CREATIVE_SOURCE = "CREATE_CREATIVE_SOURCE",
	EDIT_CREATIVE_SOURCE = "EDIT_CREATIVE_SOURCE",
	EDIT_CREATIVE_SOURCE_TO_CREATE = "EDIT_CREATIVE_SOURCE_TO_CREATE",
}

export const useCreativeSourceModal = () => {
	const [openedModal, setOpenedModal] = useState<ECreativeSourceModal | null>(null);
	const [selectedCreativeSource, setSelectedCreativeSource] = useState<CreativeSourceResponseResource | null>(null);
	const [selectedCreativeSourceToCreate, setSelectedCreativeSourceToCreate] = useState<CreativeSourceCreateOperation | CreativeSourceEditOperation | null>(null);

	const isModalOpen = useCallback((modal: ECreativeSourceModal) => openedModal === modal, [openedModal]);

	const onCloseModal = useCallback(() => {
		setOpenedModal(null);
	}, []);

	const onOpenCreateModal = useCallback(() => {
		setOpenedModal(ECreativeSourceModal.CREATE_CREATIVE_SOURCE);
	}, [setOpenedModal]);

	const onOpenEditModal = useCallback(
		(creativeSource: CreativeSourceResponseResource) => {
			setOpenedModal(ECreativeSourceModal.EDIT_CREATIVE_SOURCE);
			setSelectedCreativeSource(creativeSource);
		},
		[setOpenedModal],
	);

	const onOpenEditToCreateModal = useCallback(
		(creativeSource: CreativeSourceCreateOperation | CreativeSourceEditOperation) => {
			setOpenedModal(ECreativeSourceModal.EDIT_CREATIVE_SOURCE_TO_CREATE);
			setSelectedCreativeSourceToCreate(creativeSource);
		},
		[setOpenedModal],
	);

	return { selectedCreativeSource, isModalOpen, onCloseModal, onOpenCreateModal, onOpenEditModal, onOpenEditToCreateModal, selectedCreativeSourceToCreate };
};
